import { connect } from 'react-redux';
import { useStyles } from '../../styles';
import React from 'react';

import AccountCircle from '@material-ui/icons/AccountCircle';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {useFusionAuth} from "@fusionauth/react-sdk";

import * as authRoutines from '../../../../Containers/Auth/authRoutines';
import config from "../../../../globals/config";

const TopbarMenu = props => {
    const classes = useStyles();
    const {logout} = useFusionAuth()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleLogout = async () => {
        await logout()
        props.logout();
    };
    function handleClose() {
        setAnchorEl(null);
    }

    return (
        <div className={classes.secondaryMenu}>
            <IconButton
                aria-controls="menu-appbar"
                aria-haspopup="true"
                aria-label="Account of current user"
                color="inherit"
                data-cy="AccountIcon"
                onClick={handleMenu}
            >
                <AccountCircle />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
                data-cy="AccountMenu"
                id="menu-appbar"
                keepMounted
                onClose={handleClose}
                open={open}
                transformOrigin={{
                    horizontal: 'right',
                    vertical: 'top',
                }}
            >
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
        </div>
    );
};

const mapDispatchToProps = {
    logout: authRoutines.commandCenterLogout,
};
export default connect(
    null,
    mapDispatchToProps,
)(TopbarMenu);
